import React from "react";
import { AlertCircle } from "lucide-react";

interface AnalysisDetailProps {
  icon?: React.ReactNode;
  title?: string;
  children: React.ReactNode;
  className?: string;
}

const AnalysisDetail = ({
  icon,
  title = "Detailed analysis",
  children,
  className = "",
}: AnalysisDetailProps) => {
  return (
    <div className={className}>
      {/* Sub-heading: "Detailed analysis" in bold/blue */}
      <div className="flex items-center justify-start gap-2 mb-2">
        <span className="text-[var(--color-primary)] flex items-center justify-center">
          {icon}
        </span>
        <h4 className="font-semibold text-[var(--color-primary)] text-base flex items-center">
          {title}
        </h4>
      </div>
      {/* Main content in neutral text color */}
      <div className="ml-7 text-base text-gray-700 leading-relaxed">
        {children}
      </div>
    </div>
  );
};

export default AnalysisDetail;
